import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { Select } from 'components/input';
import { Loader } from 'components/loader';
import Pagination from 'components/pagination';
import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { ORDER_BY } from 'components/table/constants';
import { I18n, translate } from 'components/translate';
import { CommunityService, CommunityStore } from 'modules/community';
import CommentDetail from 'modules/community/history/CommentDetail';
import ContentBasePage from 'modules/content/components/ContentBasePage';
import MembershipService from 'modules/membership/MembershipService';
import PropTypes from 'prop-types';

import './CommunityHistory.scss';

@translate()
@withRouter
export default class CommunityHistory extends Component {
  static propTypes = {
    t: PropTypes.func,
    history: PropTypes.object,
    match: PropTypes.object
  };

  state = {
    loading: true,
    userName: '',
    sortComment: {},
    page: 0,
    perPage: VALUES_PER_PAGE.TEN
  };

  constructor(props) {
    super(props);

    this.backToCommunityManager = this.backToCommunityManager.bind(this);
    this.setSortComment = this.setSortComment.bind(this);
    this.getTopicComments = this.getTopicComments.bind(this);
    this.getUserName = this.getUserName.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangePerPage = this.onChangePerPage.bind(this);
  }

  async componentDidMount() {
    const latestSortComment = 0;
    const sortComment = this.sortCommentsOptions[latestSortComment];

    this.setState({ sortComment }, () => {
      this.getUserName();
      this.getTopicComments();
    });

    await CommunityService.getConfigurationData();
  }

  backToCommunityManager() {
    const { history } = this.props;

    history.push(MembershipService.getLink('community'));
  }

  setSortComment(sortComment) {
    this.setState({ sortComment }, () => {
      this.getTopicComments();
    });
  }

  async getTopicComments() {
    const { match } = this.props;
    const { sortComment, page, perPage } = this.state;

    const params = {
      sort: `commentDate,${sortComment.value}`,
      page,
      size: perPage
    };
    const { commentUserId } = match.params;

    this.setState({ loading: true });

    await CommunityService.getTopicCommentsList(params, commentUserId);
    CommunityService.getCommunityNotifications();

    this.setState({ loading: false });
  }

  async getUserName() {
    const { match } = this.props;
    const { commentUserId } = match.params;

    const userName = await CommunityService.getUserNameByCommentUserId(
      commentUserId
    );

    if (userName) {
      this.setState({ userName });
    }
  }

  onChangePage(page) {
    this.setState({ page }, () => {
      this.getTopicComments();
    });
  }

  onChangePerPage(perPage) {
    this.setState({ perPage, page: 0 }, () => {
      this.getTopicComments();
    });
  }

  get historicTitle() {
    const { t } = this.props;
    const { userName } = this.state;

    const firstNameIndex = 0;
    const firstName = userName && userName.split(' ')[firstNameIndex];

    return t('community.historic_detail_title', {
      data: { userName: firstName }
    });
  }

  get sortCommentsOptions() {
    const { t } = this.props;

    return [
      {
        value: ORDER_BY.DESC,
        label: t('general.sort.newest')
      },
      {
        value: ORDER_BY.ASC,
        label: t('general.sort.oldest')
      }
    ];
  }

  renderHeaderPage = (sortComment) => (
    <ContentBasePage.Header title={this.historicTitle} isTitleLabel={false}>
      <div className="comment-list__filter__class comment-list__history__sort-comments">
        <div>
          <label className="small mt__0">
            <I18n html label="community.sort_comments" />
          </label>

          <Select
            name="sortComments"
            isClearable={false}
            value={sortComment}
            placeholder="general.select_all"
            options={this.sortCommentsOptions}
            onChange={this.setSortComment}
          />
        </div>
      </div>
    </ContentBasePage.Header>
  );

  render() {
    const { totalElements, content } = CommunityStore;
    const { sortComment, loading, page, perPage } = this.state;
    const pagination = {
      page,
      perPage,
      totalElements
    };

    return (
      <ContentBasePage
        backHandler={this.backToCommunityManager}
        className="comment-list__history__title"
      >
        {this.renderHeaderPage(sortComment)}

        {loading && <Loader key="loader" mask />}

        <CommentDetail
          getTopicComments={this.getTopicComments}
          topicComments={content}
        />

        <Pagination
          className="comment-list__history__pagination"
          changePage={this.onChangePage}
          changePerPage={this.onChangePerPage}
          currentPage={pagination.page}
          perPage={perPage}
          numberOfElements={pagination.numberOfElements}
          totalRegisters={pagination.totalElements}
        />
      </ContentBasePage>
    );
  }
}
